import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function RefundPolicyPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Header - Mismo estilo que Home */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <Link to="/" className="text-3xl font-display font-bold text-primary-600">EspañolHub</Link>
            </div>
            <div className="hidden md:flex space-x-8 items-center">
              <Link to="/store" className="text-gray-700 hover:text-primary-600 transition font-medium">STORE</Link>
              <Link to="/blog" className="text-gray-700 hover:text-primary-600 transition font-medium">BLOG</Link>
              <Link to="/contact" className="text-gray-700 hover:text-primary-600 transition font-medium">CONTACT</Link>
              <Link to="/trial" className="bg-primary-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-primary-700 transition">
                TRIAL
              </Link>
            </div>
            <div className="md:hidden">
              <button 
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-gray-700 focus:outline-none"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  {isMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>
          {isMenuOpen && (
            <div className="md:hidden py-4 space-y-4">
              <Link to="/store" className="block text-gray-700 hover:text-primary-600 transition">STORE</Link>
              <Link to="/blog" className="block text-gray-700 hover:text-primary-600 transition">BLOG</Link>
              <Link to="/contact" className="block text-gray-700 hover:text-primary-600 transition">CONTACT</Link>
              <Link to="/trial" className="block bg-primary-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-primary-700 transition text-center">
                TRIAL
              </Link>
            </div>
          )}
        </div>
      </nav>

      {/* Hero Section - Mismo estilo que Home */}
      <section 
        className="relative py-24 lg:py-32 overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/spanish.learn.webp)',
          backgroundColor: '#FEF9C3'
        }}
      >
        {/* Background Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary-100/95 via-secondary-50/92 to-primary-50/95"></div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
          <div className="text-6xl mb-6">🛡️</div>
          <h1 className="text-5xl md:text-7xl font-display font-bold text-gray-900 mb-6 leading-tight">
            Refund Policy
          </h1>
          <h2 className="text-2xl md:text-4xl font-display font-semibold text-gray-700 mb-8">
            30-Day Money-Back Guarantee
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            No Questions Asked
          </p>
        </div>
      </section>

      {/* Guarantee Highlights */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">✅</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">30-Day Guarantee</h3>
              <p className="text-gray-600">
                Full refund within 30 days of purchase, no questions asked.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-secondary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">⚡</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Quick Processing</h3>
              <p className="text-gray-600">
                Refunds processed within 3-5 business days of approval.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎁</span>
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Keep Bonus Materials</h3>
              <p className="text-gray-600">
                Keep any bonus materials even after requesting a refund.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Policy Details */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-8">
              Our Refund Policy Details
            </h2>

            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">📋</span>
                  Eligibility Requirements
                </h3>
                <div className="bg-gray-50 rounded-lg p-6">
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">✓</span>
                      <span>Request must be made within 30 days of original purchase date</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">✓</span>
                      <span>Valid proof of purchase (order confirmation email or receipt)</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">✓</span>
                      <span>Original payment method must be available for refund processing</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-primary-600 mr-3 mt-1">✓</span>
                      <span>No reason required - we honor all refund requests within the time frame</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">🔄</span>
                  How to Request a Refund
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <ol className="space-y-4 text-gray-700">
                    <li className="flex items-start">
                      <span className="bg-secondary-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3 mt-1">1</span>
                      <div>
                        <strong>Contact our support team</strong>
                        <p className="text-sm text-gray-600 mt-1">
                          Email us at <a href="mailto:refunds@espanolhub.com" className="text-primary-600 hover:underline">refunds@espanolhub.com</a> or use our contact form
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="bg-secondary-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3 mt-1">2</span>
                      <div>
                        <strong>Provide your order information</strong>
                        <p className="text-sm text-gray-600 mt-1">
                          Include your order number, email address used for purchase, and purchase date
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="bg-secondary-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3 mt-1">3</span>
                      <div>
                        <strong>Receive confirmation</strong>
                        <p className="text-sm text-gray-600 mt-1">
                          We'll confirm your refund request within 24 hours
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start">
                      <span className="bg-secondary-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3 mt-1">4</span>
                      <div>
                        <strong>Get your refund</strong>
                        <p className="text-sm text-gray-600 mt-1">
                          Refund will be processed to your original payment method within 3-5 business days
                        </p>
                      </div>
                    </li>
                  </ol>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-primary-600 mr-3">⏰</span>
                  Processing Times
                </h3>
                <div className="bg-primary-50 rounded-lg p-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Credit Cards</h4>
                      <p className="text-gray-700 text-sm">3-5 business days after approval</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">PayPal</h4>
                      <p className="text-gray-700 text-sm">1-3 business days after approval</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Bank Transfer</h4>
                      <p className="text-gray-700 text-sm">5-7 business days after approval</p>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-2">Digital Wallets</h4>
                      <p className="text-gray-700 text-sm">1-2 business days after approval</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-display font-semibold text-gray-900 mb-4 flex items-center">
                  <span className="text-secondary-600 mr-3">ℹ️</span>
                  Important Notes
                </h3>
                <div className="bg-secondary-50 rounded-lg p-6">
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Refunds are processed to the original payment method only</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>You may keep any bonus materials received with your purchase</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Access to digital products will be revoked after refund processing</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Partial refunds are not available - all products in an order are refunded together</span>
                    </li>
                    <li className="flex items-start">
                      <span className="text-secondary-600 mr-3 mt-1">•</span>
                      <span>Currency exchange rates may affect the final refund amount for international customers</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact for Refunds */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="text-5xl mb-6">💬</div>
          <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
            Need to Request a Refund?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Our friendly support team is here to help you with your refund request.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:refunds@espanolhub.com"
              className="bg-primary-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary-700 transition transform hover:scale-105 shadow-lg"
            >
              Email Refund Request
            </a>
            <Link
              to="/contact"
              className="bg-white text-primary-600 border-2 border-primary-600 px-8 py-3 rounded-lg font-semibold hover:bg-primary-50 transition transform hover:scale-105"
            >
              Contact Support
            </Link>
          </div>
          <p className="text-sm text-gray-500 mt-4">
            Average response time: Under 24 hours
          </p>
        </div>
      </section>

      {/* Customer Satisfaction */}
      <section className="py-20" style={{ backgroundColor: '#FF6B6B' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-4">
              Customer Satisfaction Stats
            </h2>
            <p className="text-lg text-white/90">
              We're confident you'll love our products, but here are the numbers
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl font-display font-bold text-white mb-2">98.5%</div>
              <div className="text-white/90">Customer Satisfaction</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl font-display font-bold text-white mb-2">&lt; 3%</div>
              <div className="text-white/90">Refund Rate</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl font-display font-bold text-white mb-2">4.8/5</div>
              <div className="text-white/90">Average Rating</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="text-4xl font-display font-bold text-white mb-2">10,000+</div>
              <div className="text-white/90">Happy Customers</div>
            </div>
          </div>
        </div>
      </section>

      {/* Shared Footer */}
      <Footer />
    </div>
  );
}

export default RefundPolicyPage;
